import Box from '@mui/material/Box';
import QChoiceChips from 'components/QuickenControls/QChoiceChips';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './styles';

function CustomShortcuts(props) {
  const { shortcutItems, selectedShortcutId, handleShortcutSelect } = props;
  const { classes } = useStyles();

  const selectedItems = shortcutItems.filter((item) => item.id === selectedShortcutId);

  return (
    <Box className={classes.shortcutContainer}>
      <QChoiceChips
        items={shortcutItems}
        selectedItems={selectedItems}
        labelFromItem={(item) => item.label}
        keyFromItem={(item) => item.id}
        onSelected={(items) => handleShortcutSelect(items?.[0].id)}
      />
    </Box>
  );
}

CustomShortcuts.propTypes = {
  shortcutItems: PropTypes.array.isRequired,
  selectedShortcutId: PropTypes.string,
  handleShortcutSelect: PropTypes.func.isRequired,
};

export default CustomShortcuts;
